module.exports = __webpack_public_path__ + "media/1.308ba19a.mp3";